module.exports = __webpack_public_path__ + "img/img_nav_bonus_hover.768301db.svg";